import { render, staticRenderFns } from "./LetterListView.vue?vue&type=template&id=7bcdd81e&"
import script from "./LetterListView.vue?vue&type=script&lang=js&"
export * from "./LetterListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports